const CaregiverDashboard = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>Caregiver Dashboard</h1>
      <p>Welcome. Features coming soon.</p>
    </div>
  );
};

export default CaregiverDashboard;